import { Button, Card, CardContent, Container, Divider, Table, TableBody, TableCell, TableContainer, TableRow, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { ArrowBack } from "@mui/icons-material";
import { navigation } from "../../constante/navigation";

export default function AppError() {
    const location = useLocation();
    const props = location.state ? location.state : { detail: "", title: "Aucune erreur!", stackTrace: "" };


    return (
        <>
            <Container sx={{ mt: 2 }}>
                <Card sx={{ border: 4, borderColor: 'error.main' }}>
                    <CardContent>
                        <Button sx={{mb: 2}} onClick={()=> navigation.navigate!('/')}><ArrowBack/>Revenir à l'application</Button>
                        <Typography variant="h4" color="text.primary" gutterBottom>
                            Erreur {props.status}: {props.title}
                        </Typography>
                        <Divider />
                        <TableContainer>
                            <Table>
                                <TableBody>
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="h6" color="text.secondary">
                                                Description de l'erreur:
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            {props.detail}
                                        </TableCell>
                                        <TableCell>
                                            <Button onClick={() => { navigator.clipboard.writeText(props.detail) }}>
                                                <ContentCopyIcon />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell>
                                            <Typography variant="h6" color="text.secondary">
                                                Pile des appels:
                                            </Typography>
                                        </TableCell>
                                        <TableCell>
                                            {props.stackTrace}
                                        </TableCell>
                                        <TableCell>
                                            <Button onClick={() => { navigator.clipboard.writeText(props.stackTrace) }}>
                                                <ContentCopyIcon />
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </CardContent>
                </Card>
            </Container>
        </>);
}